import { c as _c } from "react/compiler-runtime";
import type { ContentSegment } from "./media-utils";
import MediaThumbnail from "./MediaThumbnail";
interface ContentSegmentComponentProps {
  readonly segment: ContentSegment;
  readonly index: number;
  readonly linkify?: boolean;
  readonly linkClassName?: string | undefined;
}
const URL_REGEX = /(https?:\/\/[^\s<]+[^\s<.,;:!?)\]"'])/g;
const DEFAULT_LINK_CLASSES = "tw-text-iron-200/90 tw-underline tw-decoration-white/20 tw-underline-offset-2 tw-transition-colors tw-duration-300 hover:tw-text-iron-50 hover:tw-decoration-white/45";
function linkifyText({
  linkClassName,
  segmentIndex,
  text
}: {
  readonly linkClassName?: string | undefined;
  readonly segmentIndex: number;
  readonly text: string;
}): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;
  let partIndex = 0;
  URL_REGEX.lastIndex = 0;
  while ((match = URL_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(<span key={`${segmentIndex}-text-${partIndex++}`}>
          {text.slice(lastIndex, match.index)}
        </span>);
    }
    parts.push(<a key={`${segmentIndex}-link-${partIndex++}`} href={match[0]} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className={linkClassName ?? DEFAULT_LINK_CLASSES}>
        {match[0]}
      </a>);
    lastIndex = URL_REGEX.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(<span key={`${segmentIndex}-text-${partIndex}`}>
        {text.slice(lastIndex)}
      </span>);
  }
  return parts.length > 0 ? parts : [text];
}

/**
 * Component to render a single segment of content (text or media)
 */
export default function ContentSegmentComponent(t0) {
  const $ = _c(11);
  const {
    segment,
    index,
    linkify: t1,
    linkClassName
  } = t0;
  const linkify = t1 === undefined ? true : t1;
  if (segment.type === "text") {
    const t2 = `segment-${index}`;
    let t3;
    if ($[0] !== index || $[1] !== linkClassName || $[2] !== linkify || $[3] !== segment.content) {
      t3 = linkify ? linkifyText({
        linkClassName,
        segmentIndex: index,
        text: segment.content
      }) : segment.content;
      $[0] = index;
      $[1] = linkClassName;
      $[2] = linkify;
      $[3] = segment.content;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
      t4 = <span key={t2}>{t3}</span>;
      $[5] = t2;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (segment.mediaInfo) {
    const t2 = `segment-${index}`;
    let t3;
    if ($[8] !== segment.mediaInfo || $[9] !== t2) {
      t3 = <MediaThumbnail key={t2} media={segment.mediaInfo} />;
      $[8] = segment.mediaInfo;
      $[9] = t2;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  return null;
}